if (!customElements.get('add-on')) {
  customElements.define(
    'add-on',
    class AddOn extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.drawer = document.querySelector('cart-drawer');
        this.upsellDrawer = this.closest('.upsell-drawer');

        this.variantId = this.dataset.variantId;
        this.type = this.dataset.type;

        this.querySelectorAll('.add-on__atc').forEach(btn => {
          btn.addEventListener('click', () => {
            this.addToCart();
          })
        })

        // event listener for cart general upsell size-chart popup btns
        this.querySelectorAll('.add-on_size-chart-toggle')?.forEach(btn => {
          btn.addEventListener('click', () => {
            this.querySelector('.addon_size-popup').classList.toggle('popup-active');
          })
        });
      }

      addToCart() {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', 1);
        formData.append('properties[_type]', this.type);

        // Adding custom properties
        if (this.upsellDrawer.dataset.parentLineItemId) {
          formData.append('properties[_parentLineItemId]', this.upsellDrawer.dataset.parentLineItemId);
        }

        if (this.upsellDrawer.dataset.parentLineItemKey) {
          formData.append('properties[_parentLineItemKey]', this.upsellDrawer.dataset.parentLineItemKey);
        }

        if (this.drawer) {
          formData.append(
            'sections',
            this.drawer.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.drawer.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'add-on',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            this.drawer.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.drawer.closeUpsellDrawer();
          });
      }
    }
  );
}


// show US market addons only if user's country is US
async function showUSAddons() {
  const userCountryCode = await window.getCountryCode();
  const cartItems = document.querySelector('.cart-items');
  if(userCountryCode === 'US') {
    cartItems.setAttribute('data-country-location', 'US');
  }
}
document.addEventListener('DOMContentLoaded', showUSAddons);